'use strict';

(function (angular) {

    // initialize basket angular app
    // bootstrap app manually as only the first app on a page can be initialized by data-ng-app (which is the framework/header)
    angular.bootstrap(document.getElementById('jwsdw-basket-module'), ['jwsdw.basket']);
}(angular));

(function (document, $) {
    $(document).on('click', '.jwsdw-basket-coupon-accordion-button', function () {
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
    });
}(document, jQuery));